import {
  fetchAllCityConfigs,
  fetchAgencies,
  upsertAdminConfig,
} from "../../services/adminConfigService";
import {
  setCityAgencies,
  setAllCityConfigs,
  upsertCityConfigs,
} from "../actions/adminConfigAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const adminConfigActionCreators = {
  fetchAllCityConfigsAction: {
    service: fetchAllCityConfigs,
    action: setAllCityConfigs,
  },
  fetchCityAgenciesAction: {
    service: fetchAgencies,
    action: setCityAgencies,
  },
  upsertAdminConfigAction: {
    service: upsertAdminConfig,
    action: upsertCityConfigs,
    responseNotification: {
      status: true,
    },
    responseNotificationMessage: () => "Configuration updated successfully.",
  },
};

export const {
  fetchAllCityConfigsAction,
  upsertAdminConfigAction,
  fetchCityAgenciesAction,
} = createAllActionCreators(adminConfigActionCreators);
